import { generateTypes } from 'reducers/utils/HttpReducerHelper';

const fundingSearchFollowers = generateTypes('FUNDING_SEARCH', 'FUNDING_SEARCH_FOLLOWERS');
const updateSearchFollower = generateTypes('FUNDING_SEARCH', 'UPDATE_SEARCH_FOLLOWER');

export { fundingSearchFollowers, updateSearchFollower };
